import NewDiscoveryModal from "./NewDiscoveryModal";
import DiscoveryAlert from "./DiscoveryAlert";

export default NewDiscoveryModal;
export { DiscoveryAlert };
